/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-unused-vars
import { numeral } from '@fund/basic-lib';
import tools from '@fund/data';
import { market as config } from '../config';
import p from './public';

// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 市场行情（走势图）- 累计收益
export default {

  // 格式化数据
  formatData: (row, buyAndSellPointData, timeName, indexName, hadyj) => {
    let data = [];
    const rowData = row;
    // 数据缺值测试
    // const testIndex = 2;
    // delete rowData.Datas[testIndex].YIELD;
    // delete rowData.Datas[testIndex].INDEXYIED;
    // delete rowData.Datas[testIndex].FUNDTYPEYIED;
    rowData.Datas = p().configureBuyAndRealData(row, buyAndSellPointData, timeName, 'PDATE');
    rowData.Datas.map(({
      PDATE, YIELD, FUNDTYPEYIED, INDEXYIED, BENCCHQUOTE,
    // eslint-disable-next-line array-callback-return
    }, index) => {
      let fData = {
        date: PDATE,
        type: timeName,
        value: p().getDataWhenEmpty(rowData.Datas, index, 'YIELD') - 0,
        real_value: tools.noData(YIELD),
        size: 1.2,
        index,
        max: rowData.Datas.length,
      };
      const items = [];
      // 获取极坐标数据
      fData = p().formatPolarPoint(fData, index, rowData, 'PDATE');

      // 设置变动点
      fData = p().setChangedPoint(fData, rowData);
      // 设置买卖点
      if (timeName === '近5年' || timeName === '成立来') {
        let nextdate = '';
        if (rowData.Datas.length > (index + 1)) {
          nextdate = rowData.Datas[index + 1].PDATE;
        }
        fData = p().setBuyAndSalePoint(fData, buyAndSellPointData, true, nextdate);
      } else {
        // 设置买卖点
        fData = p().setBuyAndSalePoint(fData, buyAndSellPointData, false, '');
      }
      // console.log(fData);
      // console.log(fData);

      // 业绩
      if (hadyj) {
        items.push({
          date: PDATE,
          type: '业绩',
          value: p().getDataWhenEmpty(rowData.Datas, index, 'BENCCHQUOTE') - 0,
          real_value: tools.noData(BENCCHQUOTE),
          size: 1,
        });
      }
      // 指数
      if (tools.hasData(indexName)) {
        items.push({
          date: PDATE,
          type: indexName,
          value: p().getDataWhenEmpty(rowData.Datas, index, 'INDEXYIED') - 0,
          real_value: tools.noData(INDEXYIED),
          size: 1,
        });
      }

      // 同类平均
      items.push({
        date: PDATE,
        type: '同类平均',
        value: p().getDataWhenEmpty(rowData.Datas, index, 'FUNDTYPEYIED') - 0,
        real_value: tools.noData(FUNDTYPEYIED),
        size: 1,
      });

      // 本基金
      items.push(fData);
      // items.reverse();

      data = data.concat(items);
    });
    console.log(data);
    return data;
  },
  // 绘制走势图
  drawChart(data, chart, alertTips, indexName, changeSlideState, isReDrawing, setLegend, hadyj) {
    // 创建十字线组件
    const {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    } = p().createToolTipsList(chart);
    const toolTipsList = {
      toolsTips, toolsTipsY, toolsTipsX, selectPoint, yTips, xTips,
    };

    // 绘制走势图
    chart.source(data, p().sourceConfig);
    // window.trackLog('drawChart-绘制走势图数据');

    // 水印
    p().drawLogo(chart);
    // window.trackLog('drawChart-水印');

    chart.scale('value', {
      nice: true,
      max: p().getMaxVal(data),
    });
    // window.trackLog('drawChart-轴线比例');

    chart.legend(false);

    chart.tooltip({
      ...p().tooltipConfig,
      yTip(val) {
        return {
          ...p().yTipsConfig,
          text: numeral(val).format('0.00%', Math.trunc),
        };
      },
      onChange: (obj) => {
        p().tooltipOnChange(obj);
        const { items } = obj;
        changeSlideState(true);
        let zsindex = 0;
        if (hadyj) {
          zsindex = 1;
        }
        // 指数
        let tlxindex = zsindex;
        if (tools.hasData(indexName)) {
          tlxindex = zsindex + 1;
        }
        const list = [
          items[tlxindex + 1].origin.real_value, // 0 本基金
          items[tlxindex].origin.real_value, // 1 同类基金
        ];

        // 2 指数
        // eslint-disable-next-line no-unused-expressions
        tools.hasData(indexName) && list.push(items[zsindex].origin.real_value);

        if (hadyj) {
          if (items[0].origin.real_value) {
            list.push(items[0].origin.real_value);
          }
        }
        setLegend(list);

        // 显示十字线
        const point = obj.items[obj.items.length - 1];
        p().showToolTips(toolTipsList, point);
      },
      onHide: () => {
        p().tooltipOnHide();
        changeSlideState(false);

        // 隐藏十字线
        p().hideToolTIps(toolTipsList);
      },
    });
    // window.trackLog('drawChart-tooltip');

    chart.axis('value', {
      ...p().yAxisGridConfig,
      label(text, index, len) {
        const cfg = {
          ...p().yAxisConfig,
          text: numeral(text).format('0.00%', Math.trunc),
        };
        return cfg;
      },
    });
    // window.trackLog('drawChart-axis value');

    chart.axis('date', {
      ...p().xAxisGridConfig,
      label: function label(text, index, total) {
        let textCfg = {
          text: text.substring(5),
        };
        if (index === 0) {
          textCfg.textAlign = 'left';
        } else if (index === total - 1) {
          textCfg.textAlign = 'right';
        } else {
          textCfg = null;
        }
        return textCfg && { ...p().xAxisConfig, ...textCfg };
      },
    });
    // window.trackLog('drawChart-axis date');

    const colors = config.colors.concat([]).reverse();
    if (!tools.hasData(indexName)) {
      colors.splice(0, 1);
    }

    const colorsnoyj = config.colorsnoyj.concat([]).reverse();
    if (!tools.hasData(indexName)) {
      colorsnoyj.splice(0, 1);
    }
    if (hadyj) {
      chart.line({ connectNulls: true }).position('date*value').color('type', colors).size('size', [1, 2])
        .animate(false);
    } else {
      chart.line({ connectNulls: true }).position('date*value').color('type', colorsnoyj).size('size', [1, 2])
        .animate(false);
    }
    // window.trackLog('drawChart-画走势线');

    // 画买卖点
    p().drawTradeMarker(data, chart);
    // window.trackLog('drawChart-画买卖点');

    // 画变动点
    p().drawChangedMarker(data, chart, alertTips);
    // window.trackLog('drawChart-画变动点');

    // 设置极点提示
    p().drawPolarTips(data, chart);
    // window.trackLog('drawChart-设置极点提示');
    chart.render();
    // window.trackLog('drawChart-chart.render');
  },
};
